import { ModalProps } from '../../../services/modals.service';
import { KeyedMutator } from 'swr';
import React from 'react';
import { useForm } from 'react-hook-form';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { CleanUser } from '../../../export-types/cleaned-types';
import { useModalClose } from '../../../utils/useModalClose';
import { trpc } from '../../../api/trpc';
import { useOutletContext } from 'react-router-dom';
import { OutletContextParams } from './users-screen.component';

interface UnLinkUserModalProps extends ModalProps {
  user?: CleanUser;
  mutate?: KeyedMutator<any>;
  orderIds?: string[];
  setSelectedOrders?: (value: Set<string>) => void;
}

export const UnLinkUserModal = ({
  user,
  close,
  mutate,
  orderIds,
  setSelectedOrders,
}: UnLinkUserModalProps) => {
  const { handleSubmit } = useForm();

  const onSubmit = handleSubmit(async () => {
    try {
      if (user) {
        await api.post(`/user/${user.id}/unlink`);
      } else if (orderIds?.length) {
        await trpc.user.userBulkLink.unlink.mutate({ ids: orderIds });
      }

      AlertService.success();
      setSelectedOrders?.(new Set());
      mutate?.();
    } catch (error: any) {
      AlertService.error(error?.message);
    } finally {
      close();
    }
  });

  const modalRef = useModalClose(close);
  const hasSelection = !!user || (orderIds && orderIds.length > 0);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={() => close()} />
        </div>

        <div className="modal-body pt-2 p-4 text-center">
          {hasSelection ? (
            <>
              <h3 className="mb-4">
                {user
                  ? 'Вы хотите отвязать менеджера от этого клиента?'
                  : 'Вы хотите отвязать менеджера от выбранных клиентов?'}
              </h3>
              <form onSubmit={onSubmit}>
                <button type="submit" className="btn btn-success w-100 mb-3">
                  Отвязать
                </button>
                <button
                  type="button"
                  className="btn btn-light w-100"
                  onClick={() => close()}
                >
                  Отменить
                </button>
              </form>
            </>
          ) : (
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-exclamation-triangle-fill mb-3 text-danger fs-1"></i>
              <h5 className="fw-bold">Вы не выбрали ни одного клиента</h5>
              <p className="mb-4 text-danger">
                Пожалуйста, выберите хотя бы одного клиента в списке, чтобы
                отвязать менеджера.
              </p>
              <button
                type="button"
                className="btn btn-outline-secondary w-100"
                onClick={() => close()}
              >
                Закрыть
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
